
import New3MapTypeBtnMixin from "@/mixins/new-3-map-type-btn";
import VueTypedMixin from "vue-typed-mixins";
import { toShortLang } from "@/mixins/common-functions";
import { fetchAnnouncementNumber } from "@/usecase/services/announcement.service";
// compoents
import MenuLanguagePrompt from "@/components/menu-view/menu-language-prompt.vue";
import MenuList from "@/components/menu-view/menu-list.vue";
import { mapGetters } from "vuex";

type MenuListRef = Vue & {
  showLogoutTitle: boolean;
  accountName: string;
};

export default VueTypedMixin(New3MapTypeBtnMixin).extend({
  name: "menu-view",
  mixins: [New3MapTypeBtnMixin],
  components: { MenuList, MenuLanguagePrompt },
  data() {
    return {
      languagePrompt: false,
    };
  },
  watch: {
    hasCurrentLocation(newVal?: boolean) {
      this.showMenuPanel(false);
      // wait for got current location
      this.closeSearchAlertUI();
      this.setGpsButtonStatus(newVal === undefined || newVal === true ? "normal" : "error");
      setTimeout(() => {
        if (newVal === true) {
          this.searchWithCurrentLocation();
        } else {
          this.searchAreaBtnClicked();
        }
      }, 300);
    },
  },
  computed: {
    ...mapGetters("ui", ["isMobile"]),
    menuListRef(): MenuListRef {
      return this.$refs.menuList as MenuListRef;
    },
  },
  async created() {
    fetchAnnouncementNumber();
    this.setIsPollBtnActive(await this.checkPollPlaces());
  },
  mounted() {
    this.$store.commit("ui/showMenuPanel", true);
    this.$store.commit("ui/stopElementScrolling", true);
  },
  beforeDestroy() {
    this.$store.commit("ui/stopElementScrolling", false);
    this.$store.commit("ui/setAnnouncementViewShown", false);
  },
  methods: {
    // map types
    searchCurrentBtnClicked() {
      this.$emit("current-location-clicked");
    },
    searchHinanjoBtnClicked() {
      this.$emit("evacuation-center-clicked");
    },
    searchPollBtnClicked() {
      this.$emit("polling-place-clicked");
    },
    setLanguagePrompt(value: boolean) {
      this.languagePrompt = value;
    },
    languageClicked(language: string) {
      this.languagePrompt = false;
      if (!this.menuListRef.showLogoutTitle)
        this.menuListRef.accountName = this.$i18n.t(`MapLeftPanel.login`) as string;
      const lang = toShortLang(language);
      const currentRoute = this.$router.currentRoute.fullPath;
      if (
        currentRoute.includes("/en") ||
        currentRoute.includes("/tw") ||
        currentRoute.includes("/cn") ||
        currentRoute.includes("/ko")
      ) {
        const country = currentRoute.substring(0, 3);
        this.$router
          .push(
            `${
              lang === undefined ? currentRoute.replace(country, "") : "/" + lang + currentRoute.replace(country, "")
            }`,
          )
          .catch(() => console.warn("push language catch"));
      } else {
        this.$router
          .push(`${lang === undefined ? currentRoute : "/" + lang + currentRoute}`)
          .catch(() => console.warn("push language catch"));
      }
    },
    closeLanguagePrompt() {
      this.languagePrompt = false;
    },
    closeMenuPanel(): void {
      // GA, GTM tracking
      this.$gtag.event("click", {
        event_category: "Menu item: Close button",
        event_label: "Close button",
        value: 1,
      });

      this.$store.commit("ui/showMenuPanel", false);
      this.$emit("close-menu");
      this.unlockViewList();
      this.resetLayerOfWhiteBgView();
    },
    unlockViewList() {
      this.$store.commit("ui/stopElementScrolling", false);
    },
    resetLayerOfWhiteBgView() {
      this.$store.commit("ui/setZIndex", 2);
    },
  },
});
